import { Form, Select } from "antd";
import { AmountType, TimeInterval } from '../../type'
import './index.less'
import { useState } from "react";
import RandomTaskTime from "../RandomTaskTime";
import { useTranslation } from "react-i18next";


export default function TransTimeSetting(props: any) {
  const { t } = useTranslation()
  const { form } = props
  const type = Form.useWatch("intervType", form);
  const intervalOptions = [
    { value: TimeInterval.NoInterval, label: t("manyToMany.noInterval") },
    { value: TimeInterval.FixedInterval, label: t("manyToMany.fixedInterval") },
    { value: TimeInterval.RandomInterval, label: t("manyToMany.randomInterval") },
  ];
  return (<div className="trans-amount-setting">
    <div className="trans-amount-setting-head">
      <h4>{ t("manyToMany.sendingInterval") }</h4>
      <Form.Item
        name="intervType"
        label={null}
        noStyle
      > 
      <Select
        style={{ minWidth: 120 }}
        options={intervalOptions}
        className="custom-select"
      />
    </Form.Item>
    </div>
    <div className="trans-amount-setting-box">
      <RandomTaskTime form={form} type={type} symbol={t("manyToMany.seconds")}/>
    </div>
  </div>)
}